import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import HomepageRolloverBody from './Body';
import { HomepageRolloverSchema } from './schema';
import {
  listItemsNeedNormalization,
  normalizeObjectList,
} from '../../../helpers/homepageUtils';

const Edit = (props) => {
  const { data, block, onChangeBlock, selected } = props;
  const intl = useIntl();
  const schema = HomepageRolloverSchema({ intl });

  useEffect(() => {
    const items = data.items || [];
    if (listItemsNeedNormalization(items)) {
      onChangeBlock(block, { ...data, items: normalizeObjectList(items) });
    }
  }, [block, data, onChangeBlock]);

  return (
    <>
      <div className="homepage-rollover-preview">
        <HomepageRolloverBody items={data.items} editPreview />
      </div>
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          formData={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default withBlockExtensions(Edit);
